// global inputs helpers

/**
 * switch inactive to active
 * @param targetElement - DOM element
 * @param apply if true force add active & no focus
 */
export function inputAriaCheckActiveState(targetElement: any, apply?: boolean): void
{
  if (targetElement.classList.contains('input-area__inactive') || apply) {
    targetElement.classList.remove('input-area__inactive')
    targetElement.classList.add('input-area__active')
    if (!apply) {
      targetElement.querySelector('input').focus()
    }
  }
}

/**
 * remove all , and set them again
 * @param x - string mainly
 * @returns new string
 */
export function numberWithCommas(x: string | number): string {
  x = '' + x
  x = x.replace(/,/g, '')
  // tslint:disable-next-line
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

